<div class="sepa-account" (click)="onClickList(sepa)">
  <div style="height: 25px;"><img class="sepa-icon" src="/assets/logo/sepa.png" alt="SEPA" style="width:25px; height:25px;"/></div>
  <div>{{sepa.name}}</div>
  <div style="padding-left: 20px">****{{sepa.last4}}</div>
  <div class="default-label" *ngIf="defaultPaymentId === sepa.payment_method_id">Default</div>
</div>